import { Component } from '@angular/core';
import { IDynamicDashboardComponent } from '../_interfaces/dynamic-dashboard-component';

@Component({
    selector: 'app-missing-widget',
    templateUrl: './missing-widget.component.html',
    styleUrls: ['./missing-widget.component.scss']
})
export class MissingWidgetComponent implements IDynamicDashboardComponent {
    hideTitle = false;
    minWidthRatio = 10;
    minHeightRatio = 10;
    minWidth = 100;
    minHeight = 100;
    hideFullScreen = true;
    widgetId: string;
}
